import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

const ImgUploadForm = () => {
  const [search, setSearch] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState('');
  const [image, setImage] = useState(null);
  const [errorMssg, setErrorMssg] = useState('');
  const [imagePreview, setImagePreview] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [banners, setBanners] = useState([]);

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      setImage(selectedImage);
      const reader = new FileReader();
      reader.onload = (event) => setImagePreview(event.target.result);
      reader.readAsDataURL(selectedImage);

      if (selectedImage.size > 300 * 1024) {
        setErrorMssg('Image size exceeds 300KB limit.');
      } else {
        setErrorMssg('');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('image', image);

    try {
      const response = await fetch(`/api/BannerImg`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setTitle('');
        setImage(null);
        setImagePreview(null);
        setErrorMssg('');
        setShowModal(false);
        await handleDateChange(fromDate, toDate); 
      } else {
        setErrorMssg('Failed to upload image.');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      setErrorMssg('Error uploading image.');
    }
  };

  const handleDateChange = async (from, to) => {
    if (!from || !to) return;

    try {
      const response = await fetch(`/api/ViewBannerForm`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Fromdate: from, Todate: to }),
      });

      if (response.ok) {
        const data = await response.json();
        setBanners(data);
      } else {
        setErrorMssg('Failed to fetch banners.');
      }
    } catch (error) {
      console.error('Error fetching banners:', error);
      setErrorMssg('Error fetching banners.');
    }
  };

  const toggleStatus = async (BID, newStatus) => {
    try {
      const response = await fetch(`/api/ToggleBannerStatus`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ BID, status: newStatus }),
      });

      if (response.ok) {
        await handleDateChange(fromDate, toDate);
      } else {
        console.error("Toggle failed");
      }
    } catch (error) {
      console.error("Toggle error", error);
    }
  };

  const handleReset = () => {
    setTitle('');
    setImage(null);
    setImagePreview(null);
    setErrorMssg('');
    setSearch(false);
    setFromDate('');
    setToDate('');
    setBanners([]);
  };

  return (
    <div className="container my-3">
      <div className='row'>
        <div className={search ? 'col-12' : 'd-none'}>
          <div className='row shadow-sm p-3 bg-white rounded align-items-end'>
            <div className='col-12 col-sm-6 col-md-4 mb-2'>
              <TextField
                label="From Date"
                type="date"
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  handleDateChange(e.target.value, toDate);
                }}
                variant="standard"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className='col-12 col-sm-6 col-md-4 mb-2'>
              <TextField
                label="To Date"
                type="date"
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                  handleDateChange(fromDate, e.target.value);
                }}
                variant="standard"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div className='col-12 col-md-4 mb-2'>
              <Button variant='contained' color='secondary' onClick={handleReset} fullWidth>
                Reset
              </Button>
            </div>
          </div>
        </div>

        {!search && (
          <div className='col-12 '>
            <p className="habttn" onClick={() => setShowModal(true)}>
              <i className='bi bi-plus fs-3'></i><b>Add Package </b>
            </p>
            <p className="habttn text-primary" onClick={() => setSearch(true)}>
              <i className='bi bi-search fs-5'></i><b>Search Package</b>
            </p>
          </div>
        )}
      </div>

      {banners.length > 0 && (
        <div className="row mt-4">
          {banners.map((banner) => (
            <div key={banner.BID} className="col-md-3 mb-3">
              <div className="card h-100">
                <img
                  src={`/Uploads/${banner.URL}`}
                  className="card-img-top"
                  alt={banner.Title}
                  style={{ height: '180px', objectFit: 'cover' }}
                />
                <div className="card-body">
                  <h6 className="card-title">{banner.Title}</h6>

                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <span className={`badge ${banner.Status === 1 ? 'bg-success' : 'bg-secondary'}`}>
                      {banner.Status === 1 ? 'Active' : 'Inactive'}
                    </span>

                    <Button
                      size="small"
                      variant="contained"
                      color={banner.Status === 1 ? 'error' : 'primary'}
                      onClick={() => toggleStatus(banner.BID, banner.Status === 1 ? 0 : 1)}
                    >
                      {banner.Status === 1 ? 'Deactivate' : 'Activate'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <>
          <div className="modal fade show" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content p-3">
                <div className="modal-header">
                  <h5 className="modal-title">Upload Image</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <input
                      type="text"
                      className="form-control"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Image</label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleImageChange}
                      accept="image/*"
                      required
                    />
                    {errorMssg && <small className="text-danger">{errorMssg}</small>}
                  </div>
                  {imagePreview && (
                    <div className="mb-3 text-center">
                      <img
                        src={imagePreview}
                        alt="Preview"
                        className="img-fluid rounded"
                        style={{ maxHeight: '300px' }}
                      />
                    </div>
                  )}
                  <div className="d-grid">
                    <button type="submit" className="btn btn-primary">Upload</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </div>
  );
};

export default ImgUploadForm;
